// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseSuperAdminFactory instead of class inheritance

import { createBaseSuperAdmin, type IBaseSuperAdmin } from "../BaseSuperAdminFactory";
import type { RolePermissionsMatrixApiResponse as SharedRolePermissionsMatrixApiResponse } from "./RolePermissionsTypes";

// Re-export the type for backward compatibility
export type RolePermissionsMatrixApiResponse = SharedRolePermissionsMatrixApiResponse;

interface RolePermissionsInstance {
	getMatrix(): Promise<RolePermissionsMatrixApiResponse>;
}

// Module-level singleton instance
let instance: RolePermissionsInstance | null = null;
let baseSuperAdminInstance: IBaseSuperAdmin | null = null;

function createRolePermissions(): RolePermissionsInstance {
	if (!baseSuperAdminInstance) {
		baseSuperAdminInstance = createBaseSuperAdmin();
	}

	const baseSuperAdmin = baseSuperAdminInstance;

	return {
		getMatrix: async (): Promise<RolePermissionsMatrixApiResponse> => {
			const url = new URL(baseSuperAdmin.namespaceUrl.concat("/role-permissions"));
			try {
				return await baseSuperAdmin.getRequest<RolePermissionsMatrixApiResponse>(url);
			} catch (err) {
				// Ne pas logger les erreurs 401 car elles sont attendues au chargement initial
				const status = (err as { response?: { status?: number } })?.response?.status;
				if (status !== 401) {
					baseSuperAdmin.onError(err);
				}
				return Promise.reject(err);
			}
		},
	};
}

export function getRolePermissionsInstance(): RolePermissionsInstance {
	if (!instance) {
		instance = createRolePermissions();
	}
	return instance;
}
